import EzController from 'controllers/ez-base-controller';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import {
  REACTIVATION_BANNER_TRIGGERED,
  REACTIVATION_BANNER_COMPLETE,
} from 'components/analytics/conversions/constants/actions';

export default class ReactivationBannerController extends EzController {
  declare readonly element: HTMLElement;

  connect() {
    sendTrackingEvent({
      element: this.element,
      data: {
        action: REACTIVATION_BANNER_TRIGGERED,
        non_interaction: true,
      },
    });
  }

  trackComplete = (event) => {
    sendTrackingEvent({
      element: event.currentTarget,
      data: {
        action: REACTIVATION_BANNER_COMPLETE,
      },
    });
  }
}
